import { render } from "./Phone.vue.js?vue&type=template&id=dc388f5a!=!../vue-loader/dist/index.js??ruleSet[0]!./Phone.vue?vue&type=template&id=dc388f5a"
import script from "./Phone.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Phone.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__